"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Itinerary = exports.Usage = exports.Members = exports.ItinerariesStat = exports.OrgStatistic = exports.MinOrganisationDto = exports.OrganisationCreateDto = void 0;
class OrganisationCreateDto {
    _id;
    friendlyName;
    creatorEmail;
    status;
}
exports.OrganisationCreateDto = OrganisationCreateDto;
/**
 * @description This is the minimum information needed for unauthenticated users
 *
 */
class MinOrganisationDto {
    _id;
    friendlyName;
}
exports.MinOrganisationDto = MinOrganisationDto;
class OrgStatistic {
    members;
    itineraries;
    usage;
}
exports.OrgStatistic = OrgStatistic;
class ItinerariesStat {
    total;
    deleted;
    visibleInApp;
    pending;
}
exports.ItinerariesStat = ItinerariesStat;
class Members {
    total;
    deleted;
    pendingInvites;
    completed;
    activeLastDay;
    activeLastWeek;
    activeLastMonth;
}
exports.Members = Members;
class Usage {
    start;
    end;
    memberEvents;
    itineraries;
}
exports.Usage = Usage;
class Itinerary {
    id;
    time_created;
    time_updated;
    name;
    properties;
}
exports.Itinerary = Itinerary;
